"use client";

import React from "react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
export default function WhoWeAre() {
  return <section id="whoweare" data-nav="light" className="relative bg-background text-foreground py-24 md:py-32 lg:py-36 overflow-hidden border-b border-border/40">
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="flex flex-col items-start text-left">
          <Badge variant="outline" className="mb-6 uppercase tracking-widest text-xs font-semibold px-3.5 py-1 text-accent border-accent/30 bg-accent/5 rounded-full">
            Who We Are
          </Badge>

          <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium text-foreground leading-relaxed md:leading-[1.6] tracking-tight mb-0">
            KTEX FZCO is a Dubai-based B2B wholesale trading company specialising in mobile phones and consumer electronics. Operating from DAFZA, we connect verified global suppliers with international buyers across 40+ countries — with zero inventory risk and fast deal execution.
          </p>
        </motion.div>
      </div>
    </section>;
}